import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 1 }

import { useDialogsStore } from '@/store/dialogs';
import { defineAsyncComponent } from 'vue';
import { configRegistry } from '@/lib/configRegistry';


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailsDialogs',
  setup(__props) {

const dialogsStore = useDialogsStore();

function getDetailComponent(moduleName?: string) {
  if (!moduleName) return null;
  const loader = configRegistry[moduleName];
  if (loader) {
    return defineAsyncComponent(async () => {
      const mod = await loader();
      return mod?.DETAIL?.component;
    });
  }
  return null;
}

return (_ctx: any,_cache: any) => {
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(dialogsStore).openDialog1 && _unref(dialogsStore).openDialog1.open)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 'dlg1-' + (_unref(dialogsStore).openDialog1?.module ?? '') + '-' + (_unref(dialogsStore).openDialog1?.id ?? ''),
          modelValue: _unref(dialogsStore).openDialog1.open,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dialogsStore).openDialog1.open) = $event)),
          fullscreen: "",
          persistent: ""
        }, {
          default: _withCtx(() => [
            (getDetailComponent(_unref(dialogsStore).openDialog1?.module))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(getDetailComponent(_unref(dialogsStore).openDialog1.module)), _mergeProps({ key: 0 }, _unref(dialogsStore).openDialog1.props, {
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(dialogsStore).closeBy(_unref(dialogsStore).openDialog1.module, _unref(dialogsStore).openDialog1.id)))
                }), null, 16))
              : (_openBlock(), _createElementBlock("div", _hoisted_1, " No se encontró el componente detalle de \"" + _toDisplayString(_unref(dialogsStore).openDialog1?.module) + "\" ", 1))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_unref(dialogsStore).openDialog2 && _unref(dialogsStore).openDialog2.open)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 'dlg2-' + (_unref(dialogsStore).openDialog2?.module ?? '') + '-' + (_unref(dialogsStore).openDialog2?.id ?? ''),
          modelValue: _unref(dialogsStore).openDialog2.open,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(dialogsStore).openDialog2.open) = $event)),
          fullscreen: "",
          persistent: ""
        }, {
          default: _withCtx(() => [
            (getDetailComponent(_unref(dialogsStore).openDialog2?.module))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(getDetailComponent(_unref(dialogsStore).openDialog2.module)), _mergeProps({ key: 0 }, _unref(dialogsStore).openDialog2.props, {
                  onClose: _cache[2] || (_cache[2] = ($event: any) => (_unref(dialogsStore).closeBy(_unref(dialogsStore).openDialog2.module, _unref(dialogsStore).openDialog2.id)))
                }), null, 16))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, " No se encontró el componente detalle de \"" + _toDisplayString(_unref(dialogsStore).openDialog2?.module) + "\" ", 1))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_unref(dialogsStore).openDialog3 && _unref(dialogsStore).openDialog3.open)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 'dlg3-' + (_unref(dialogsStore).openDialog3?.module ?? '') + '-' + (_unref(dialogsStore).openDialog3?.id ?? ''),
          modelValue: _unref(dialogsStore).openDialog3.open,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(dialogsStore).openDialog3.open) = $event)),
          fullscreen: "",
          persistent: ""
        }, {
          default: _withCtx(() => [
            (getDetailComponent(_unref(dialogsStore).openDialog3?.module))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(getDetailComponent(_unref(dialogsStore).openDialog3.module)), _mergeProps({ key: 0 }, _unref(dialogsStore).openDialog3.props, {
                  onClose: _cache[4] || (_cache[4] = ($event: any) => (_unref(dialogsStore).closeBy(_unref(dialogsStore).openDialog3.module, _unref(dialogsStore).openDialog3.id)))
                }), null, 16))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, " No se encontró el componente detalle de \"" + _toDisplayString(_unref(dialogsStore).openDialog3?.module) + "\" ", 1))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}
}

})